import PropTypes from 'prop-types';

const {
  string, shape,
} = PropTypes;

export const UserProps = shape({
  id: PropTypes.number,
  name: PropTypes.string,
  email: PropTypes.string,
  avatar: PropTypes.string,
  registered: PropTypes.any,
  accepted: PropTypes.any,
  underReview: PropTypes.bool,
  isCustomer: PropTypes.any,
  isPayingCustomer: PropTypes.any,
  isTrialStarted: PropTypes.bool,
  trialArmPings: PropTypes.number,
  pings: PropTypes.number,
  type: PropTypes.string,
  mailboxConnected: PropTypes.any,
  completion: PropTypes.number,
  campaigns: PropTypes.number,
  appSubmitted: PropTypes.bool,
});

export const SidebarProps = shape({
  show: PropTypes.bool,
  collapse: PropTypes.bool,
});

export const TopbarProps = shape({
  bookingLink: PropTypes.string,
});

export const ThemeProps = shape({
  className: string,
});
